import React from "react";
import cs from "classnames";
import styles from "./index.module.css";
import { InitPPTResponseRecommendItem } from "@/services/workbench/types";

interface TryProps {
  recommendPromptList: InitPPTResponseRecommendItem[];
  activeRecommendIndex?: number;
  keyword?: string;
  recommendClick?: (
    item: InitPPTResponseRecommendItem,
    index: number,
    create?: boolean
  ) => void;
}

const Try = (props: TryProps) => {
  const { recommendPromptList, activeRecommendIndex, recommendClick, keyword } =
    props;
  return (
    <div className={styles.try}>
      <div className={styles.title}>
        <span>试试这些</span>
      </div>
      <div className={styles.recommends}>
        {recommendPromptList.map((item, index) => {
          return (
            <div
              key={item.prompt}
              className={cs(styles.recommend, {
                [styles.active]:
                  index === activeRecommendIndex && keyword === item.prompt,
              })}
              onDoubleClick={() => recommendClick?.(item, index)}
              onClick={() => recommendClick?.(item, index, false)}
            >
              {item.recommend}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(Try);
